<script lang="ts" setup>

  import { useI18n } from 'vue-i18n'
  import { useMutation } from '@tanstack/vue-query'

  import { useAuthService } from '~/core/services'

  const emit = defineEmits<{
    (e: 'close'): void
  }>()
  const { logout } = useAuthService()
  const { reset } = useCartStore()

  const { user, fetched } = storeToRefs(useUserStore())
  const router = useRouter()
  const { matches: matchDesktop } = useMatchMedia(ScreenWidth.desktop)

  const { t } = useI18n()
  const { mutate } = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      user.value = null
      fetched.value = false
      reset()
      router.push('/')
    },
  })

  function close() {
    emit('close')
  }

</script>

<template>
  <div class="c-account-dropdown">
    <div
      v-if="user"
      class="content"
    >
      <div
        class="link-icon"
        @click="close"
      >
        <NuxtLink
          to="/profile"
          class="link"
        >
          {{ t("navigation.my-informations") }}
        </NuxtLink>
        <SvgIcon icon="account" />
      </div>
      <div
        v-show="matchDesktop"
        class="link-icon"
        @click="close"
      >
        <NuxtLink
          to="/reservations"
          class="link"
        >
          {{ t("navigation.my-reservations") }}
        </NuxtLink>
        <SvgIcon icon="reservations" />
      </div>
      <div
        class="link-icon"
        @click="close"
      >
        <a
          href="javascript:void(0)"
          class="link"
          @click="() => mutate()"
        >
          {{ t("navigation.disconnect") }}
        </a>
        <SvgIcon icon="disconnect" />
      </div>
    </div>
  </div>
</template>

<style scoped>

.c-account-dropdown {
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;

  .content {
    display: flex;
    width: 100%;
    min-width: 100%;
    flex-direction: column;

    .user-name {
      display: flex;
      width: 100%;
      justify-content: flex-end;
      margin-bottom: 1rem;
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 1.125rem;
      font-weight: 700;
    }

    .link-icon {
      display: flex;
      width: 100%;
      align-items: flex-end;
      justify-content: flex-end;
      padding: 1em 0;

      .link {
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 1.125rem;
        font-weight: 600;
        line-height: 1.5em;
      }

      .c-icon {
        margin-left: 0.625rem;
        color: var(--color-primary);
      }
    }
  }
}
</style>
